import React from 'react'

import i18n from 'modules/core/lib/i18n'

/**
 *
 * @param maxTaskNameLength default set to 255 char
 * @returns
 */
export const useValidateStringLength = (maxTaskNameLength = 255) => {
  const [isValid, setIsValid] = React.useState(false)

  const validate = (name: string) => {
    if (name.length === 0) {
      setIsValid(false)
      return i18n.t('tasks.form.name_presence_error')
    }

    if (name.length > maxTaskNameLength) {
      setIsValid(false)
      return i18n.t('tasks.form.name_length_error')
    }

    setIsValid(true)

    return undefined
  }

  return {
    isValid,
    validate,
  }
}
